
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    ListItemIcon, ListItemText, Menu, Stack,
    Tooltip
} from "@mui/material";

// App Imports

import {
    contractSearch, deleteContract, deleteContractById
} from "../../Contract/ContractClient";
import {changeContractSearch} from "./contractSearchSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";
import ContractSearch from "./ContractSearch";
import {ContractSearchGridColumns} from "./ContractSearchGridColumns";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {changeWorkQueue} from "../workQueueSlice";



// main function
export default function ContractSearchGrid() {

    // ****************** BEGIN STATES ****************************

    const [contract, setContract] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorId = useSelector((state) => state.contractSearchSlc.value.id);
    const selectorIdFrom = useSelector((state) => state.contractSearchSlc.value.idFrom);
    const selectorIdTo = useSelector((state) => state.contractSearchSlc.value.idTo);
    const selectorContractType = useSelector((state) => state.contractSearchSlc.value.contractType);
    const selectorMcode = useSelector((state) => state.contractSearchSlc.value.mcode);
    const selectorName = useSelector((state) => state.contractSearchSlc.value.name);
    const selectorCreatedOn = useSelector((state) => state.contractSearchSlc.value.createdOn);
    const selectorCreatedFrom = useSelector((state) => state.contractSearchSlc.value.createdFrom);
    const selectorCreatedTo = useSelector((state) => state.contractSearchSlc.value.createdTo);

    const controlsSearchState = useSelector((state) => state.contractSearchSlc.value.searchState);

    const selectedId = useSelector((state) => state.contractSearchSlc.value.id);

    const rowSelectedContractId  = useSelector((state) => state.workQueueSlc.value.selectedContractId);


    const dispatchData = useDispatch();

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    const fetchContract = () =>{
        console.log("Fetch triggered");
        console.log("selectorId", selectorId);
        console.log("selectorIdFrom", selectorIdFrom);
        console.log("selectorIdTo", selectorIdTo);
        console.log("selectorContractType", selectorContractType);
        console.log("selectorMcode", selectorMcode);
        console.log("selectorName", selectorName);
        console.log("selectorCreatedOn", selectorCreatedOn);
        console.log("selectorCreatedFrom", selectorCreatedFrom);
        console.log("selectorCreatedTo", selectorCreatedTo);
        if(
            // selectorId === "1000"
            selectorId !== null ||
            selectorIdFrom !== null ||
            selectorIdTo !== null ||
            selectorContractType !== null ||
            selectorMcode !== null ||
            selectorName !== null ||
            selectorCreatedOn !== null ||
            selectorCreatedFrom !== null ||
            selectorCreatedTo !== null
        )
        {
            {
                contractSearch(
                    selectorId,
                    selectorIdFrom,
                    selectorIdTo,
                    selectorContractType,
                    selectorMcode,
                    selectorName,
                    selectorCreatedOn,
                    selectorCreatedFrom,
                    selectorCreatedTo
                )

                    .then(data => {
                            console.log(data);
                            setContract(data);
                        }
                    )
            }
        }
        else{console.log("search triggered, nothing to search.")}}

    // ****************** END FETCH ****************************



    const renderContract = contract => {
        if (contract.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }



    function handleSearch(){
        dispatchData(changeContractSearch({searchState: !controlsSearchState}));
    }

    useEffect(() => {
        fetchContract();
        dispatchData(changeContractSearch({contractSearchGridRefresh: false}));
    }, [useSelector((state) => state.contractSearchSlc.value.contractSearchGridRefresh)===true]);


    // ****************** BEGIN CRUD ***********************************


    const removeContract = () => {
        console.log("const removeContract in ContractSearchGrid.js called");
        console.log("rowSelectedContractId, ", rowSelectedContractId);
        deleteContractById(rowSelectedContractId).then(() => {
        // deleteContract(selectorId).then(() => {
            // successNotification("Data Point Attribute deleted", `Data Point Attribute with id ${selectorContractSearchId} was deleted`);
            setDeleteOpen(false);
            dispatchData(changeContractSearch({contractSearchGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };


    function DeleteConfirmationDialog() {

        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            console.log("const handleDelete in ContractSearchGrid.js called");
            deleteContract(selectedId).then(() => {
                setDeleteOpen(false);
                dispatchData(changeContractSearch({contractSearchGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };

    // ****************** END CRUD ***********************************



    // ****************** BEGIN DRILLDOWN ****************************

    // ****************** END DRILLDOWN ****************************

    const handleClickedRow = (contract) => {

        console.log('ContractSearch data from clicked row');
        console.log(contract);
        dispatchData(changeContractSearch({id: contract.id, idFrom: contract.idFrom, idTo: contract.idTo,
            contractType: contract.contractType, mcode: contract.mcode, name: contract.name,
            craatedOn: contract.createdOn, createdFrom: contract.createdFrom, createdTo: contract.createdTo}));
        dispatchData(changeWorkQueue({
            selectedContractId: contract.id,
            selectedContractName: contract.name,
            selectedContractDisplayFolders: true,
            selectedContractSectionId: 0,
            contractHeaderState: true,
            workQueueCDPGridRefresh: true,
            workQueueCSGridRefresh: true,
            triggerAdvance: false

        }));
    };


    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: 680 }}>
            {/*<Box sx={{height: 60, pt: 1, pl: 3}}>*/}
                <Box sx={{  pl: 3}}>
                <Stack direction={"horizontal"}>
                    <h3>Contracts</h3>
                    <SearchIcon
                        sx={{pt: 3, ml: 2}}  color={'primary'}
                        onClick={handleSearch}
                    />

                </Stack>
            </Box>
            {showSearch && <ContractSearch/>}
            {/*{selectorDrawerState && <ContractDrawer*/}
            {/*/>}*/}
            {gridVisible && <DataGrid
                sx={{
                    '& .MuiDataGrid-cell': {
                        cursor: 'pointer',
                        backgroundColor: "rgb(69,177,232)"
                    },
                }}
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Contract"}
                rows={contract}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={ContractSearchGridColumns({
                    hideActions,
                    onEdit: () => dispatchData(changeContractSearch({ contractSearchDrawerState: true, contractSearchDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeContractSearch({ contractSearchDrawerState: true, contractSearchDrawerMode: "Clone" })),
                    onDelete: removeContract
                })}
                onRowClick = {(contract)=>handleClickedRow(contract.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={contractSearch => contractSearch.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        // handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}


